import { Text, TextArea } from '@soteria/design-system-ve';

import * as styles from '../AuditDecisionPanel.css';
import * as spacingStyles from '../spacing.css';

interface CommentsSectionProps {
  comments: string;
  isSessionCompleted: boolean;
  onCommentsChange: (value: string) => void;
}

export function CommentsSection({ comments, isSessionCompleted, onCommentsChange }: CommentsSectionProps) {
  return (
    <div className={spacingStyles.sectionContainer}>
      <Text className={styles.sectionTitle}>Comments (optional)</Text>
      <TextArea
        disabled={isSessionCompleted}
        placeholder="Add any additional notes about your decision..."
        rows={3}
        value={comments}
        onChange={e => onCommentsChange(e.target.value)}
      />
    </div>
  );
}
